import { useMutation } from '@gogame/query';

import { updateSubscription } from '../../source/subscriptions';
import { update } from '../queryKeyFactory';
import { errorMessageGetter } from './useErrorDifferentFormatGetter';

export const useUpdateSubscription = () => {
  const updateMutation = useMutation(update(), updateSubscription, {
    refresh: true,
    successMessage: () => 'Subscription Updated',
    errorMessage: errorMessageGetter,
  });
  return [updateMutation.mutateAsync, updateMutation];
};
